// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__QiI6B","item":"pagination_item__PAJVt"};